import { render, staticRenderFns } from "./TemplateCenter.vue?vue&type=template&id=6ca5f582&scoped=true"
import script from "./TemplateCenter.vue?vue&type=script&lang=js"
export * from "./TemplateCenter.vue?vue&type=script&lang=js"
import style0 from "./TemplateCenter.vue?vue&type=style&index=0&id=6ca5f582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5f582",
  null
  
)

export default component.exports